import React,{ useContext } from 'react'
import { useLocation } from 'react-router-dom'
import CircularProgress from "@material-ui/core/CircularProgress";

import AlertPermanent from "../core/AlertPermanent"
import ModalContext from "../../context/modal/modalContext"
import ReceiverContext from '../../context/receiver/ReceiverContext'
import * as Strings from './strings'

import './receivers.css'

const RECEIVER_TYPE_CUSTOMER = 1
const RECEIVER_TYPE_PROVIDER = 2

const ReceiverCreator = function(props){
    const location = useLocation()
    //console.log('ReceiverCreator')
    const receiverContext =  useContext(ReceiverContext)
    const {
        postReceiver,
        putReceiver,
        currentType,
        history,
        completed,
        setCurrentItem,
        subError,
        receiversClearResults
    } = receiverContext

    const [newReceiver,setNewReceiver]=React.useState()
    const [title,setTitle]=React.useState()
    const [editing,setEditing]=React.useState(false)
    const [loading,setLoading] = React.useState(false)
    const toPage = (page) => {
        history.push(`/app/${page}`);
    };
    const back=()=>{
        //setCurrentItem(null)
        toPage(currentType===RECEIVER_TYPE_CUSTOMER?'customers':'providers')
    }

    function setField(event){
        try{
            setNewReceiver({
                ...newReceiver,
                [event.currentTarget.attributes.name.value]: event.currentTarget.value
            })
        }catch(err){
            //console.error(err)
        }
    }

    function save(){
        try{
            setLoading(true)
            const customers = JSON.parse(localStorage.getItem('customers'))
         //   //console.table(customers)
            const nr = {
                ...newReceiver,
               [Strings.RECEIVER_CREATION_FIELD_0_NAME]: props.type,
               [Strings.RECEIVER_CREATION_FIELD_9_NAME]: customers[0].id
            }
            if(newReceiver&&newReceiver.id){
                nr.receiverId= newReceiver.id
                delete nr.id
            }
            if(!props.data) postReceiver(nr)
            else putReceiver(nr)
        }
        catch(error){
            if(error.errorMessage) alert(error.errorMessage)
            else
            alert('Por favor complete los datos')
           // //console.error(error)
        }
    }
    React.useEffect(()=>{
        if(loading)receiversClearResults()
    },[loading])
    React.useEffect(()=>{
       if(currentType)
         setTitle(currentType===RECEIVER_TYPE_CUSTOMER ? Strings.RECEIVER_UPLOADER_TITLE_CUSTOMER : Strings.RECEIVER_UPLOADER_TITLE_PROVIDER)
    },[currentType])

    React.useEffect(()=>{
      // //console.log(completed)
       if(completed==='COMPLETED'){
            receiversClearResults()
            back()
       }
        setLoading(false)
    },[completed])

    React.useEffect(()=>{
        if(subError&&subError!=='') setLoading(false)
    },[subError])


    React.useEffect(()=>{
        setLoading(false)
      //  //console.log('props',props)
        if(props.data) {
            setNewReceiver({...props.data})
            setEditing(true)
        }
    },[])

    return(
        <div className="provider-creator">
            <div className="provider-creator-field">
                <label className="provider-creator-label" htmlFor={Strings.RECEIVER_CREATION_FIELD_1_NAME}>
                    {Strings.RECEIVER_CREATION_FIELD_1_LABEL}
                </label>
                {
                    editing && <span>{newReceiver[Strings.RECEIVER_CREATION_FIELD_1_NAME]}</span>
                }
                {
                    !editing && <input className="provider-creator-input"
                                           type="text"
                                           placeholder={Strings.RECEIVER_CREATION_FIELD_1_PLACEHOLDER}
                                           onChange={setField}
                                           name={Strings.RECEIVER_CREATION_FIELD_1_NAME}
                                           defaultValue={newReceiver?newReceiver[Strings.RECEIVER_CREATION_FIELD_1_NAME]:null}
                                    />
                }

            </div>
             <div className="provider-creator-field ">
                <label className="provider-creator-label" htmlFor={Strings.RECEIVER_CREATION_FIELD_2_NAME}>
                    {Strings.RECEIVER_CREATION_FIELD_2_LABEL}
                </label>
                {
                    editing && <span>{newReceiver[Strings.RECEIVER_CREATION_FIELD_2_NAME]}</span>
                }
                {
                    !editing &&<input className="provider-creator-input"
                       type="text"
                       placeholder={Strings.RECEIVER_CREATION_FIELD_2_PLACEHOLDER}
                       onChange={setField}
                       name={Strings.RECEIVER_CREATION_FIELD_2_NAME}
                       defaultValue={newReceiver?newReceiver[Strings.RECEIVER_CREATION_FIELD_2_NAME]:null}
                    />
                }
             </div>
             <div className="provider-creator-field">
                <label className="provider-creator-label"  htmlFor={Strings.RECEIVER_CREATION_FIELD_3_NAME}>
                    {Strings.RECEIVER_CREATION_FIELD_3_LABEL}
                </label>
                <input className="provider-creator-input"
                       type="text"
                       placeholder={Strings.RECEIVER_CREATION_FIELD_3_PLACEHOLDER}
                       onChange={setField}
                       name={Strings.RECEIVER_CREATION_FIELD_3_NAME}
                         defaultValue={newReceiver?newReceiver[Strings.RECEIVER_CREATION_FIELD_3_NAME]:null}
                         
                />
            </div>
             <div className="provider-creator-field">
                <label className="provider-creator-label" htmlFor={Strings.RECEIVER_CREATION_FIELD_4_NAME}>
                    {Strings.RECEIVER_CREATION_FIELD_4_LABEL}
                </label>
                <input className="provider-creator-input"
                       type="text"
                       placeholder={Strings.RECEIVER_CREATION_FIELD_4_PLACEHOLDER}
                       onChange={setField}
                       name={Strings.RECEIVER_CREATION_FIELD_4_NAME}
                         defaultValue={newReceiver?newReceiver[Strings.RECEIVER_CREATION_FIELD_4_NAME]:null}
                />
            </div>
             <div className="provider-creator-field">
                <label className="provider-creator-label" htmlFor={Strings.RECEIVER_CREATION_FIELD_5_NAME}>
                    {Strings.RECEIVER_CREATION_FIELD_5_LABEL}
                </label>
                <input className="provider-creator-input"
                       type="text"
                       placeholder={Strings.RECEIVER_CREATION_FIELD_5_PLACEHOLDER}
                       onChange={setField}
                       name={Strings.RECEIVER_CREATION_FIELD_5_NAME}
                     defaultValue={newReceiver?newReceiver[Strings.RECEIVER_CREATION_FIELD_5_NAME]:null}
                />
            </div>
             <div className="provider-creator-field">
                <label className="provider-creator-label" htmlFor={Strings.RECEIVER_CREATION_FIELD_6_NAME}>
                    {Strings.RECEIVER_CREATION_FIELD_6_LABEL}
                </label>
                <input className="provider-creator-input"
                       type="text"
                       placeholder={Strings.RECEIVER_CREATION_FIELD_6_PLACEHOLDER}
                       onChange={setField}
                       name={Strings.RECEIVER_CREATION_FIELD_6_NAME}
                         defaultValue={newReceiver?newReceiver[Strings.RECEIVER_CREATION_FIELD_6_NAME]:null}
                />
            </div>
             <div className="provider-creator-field">
                <label className="provider-creator-label" htmlFor={Strings.RECEIVER_CREATION_FIELD_7_NAME}>
                    {Strings.RECEIVER_CREATION_FIELD_7_LABEL}
                </label>
                <input className="provider-creator-input"
                       type="text"
                       placeholder={Strings.RECEIVER_CREATION_FIELD_7_PLACEHOLDER}
                       onChange={setField}
                       name={Strings.RECEIVER_CREATION_FIELD_7_NAME}
                         defaultValue={newReceiver?newReceiver[Strings.RECEIVER_CREATION_FIELD_7_NAME]:null}
                />
            </div>
            {
                 subError && subError!=null && subError!='' && <AlertPermanent category="error" message={subError} />
            }
            {
            loading? ( <CircularProgress /> ) : (
            <div className="provider-creator-buttons">
                <button className="provider-creator-button-primary" onClick={save}>
                    {Strings.RECEIVER_CREATION_BUTTON_PRIMARY_LABEL}
                </button>
                <button className="provider-creator-button-secondary" onClick={back}>
                    {Strings.RECEIVER_CREATION_BUTTON_SECONDARY_LABEL}
                </button>
            </div>
            )}

        </div>
    )
}
export default ReceiverCreator